import BasePolicy from '@/policies/BasePolicy.js';

export default class ItemHeaderPolicy extends BasePolicy {
    // Only roles defined in before() can see
    view(user) {
        return false;
    }
}
